/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : swaggerApis.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 12-07-2024
 * @description  Swagger API documentation Apis
 */
import actionType from "../actionTypes";
const swaggerApis = {
  get_ucm_docs: {
    api_name: "/UCM/docs",
    https_method: "GET",
    action_type: actionType.GET_SWAGGER_DATA,
    description:
      "Get the user configuration management swagger api documentation",
  },
};

export default swaggerApis;
